import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { Editor } from './components/Editor';
import { Home } from './components/Home';

function Layout() {
  return (
    <div className="app-layout">
      <Sidebar />
      <main className="app-content">
        <Outlet />
      </main>
    </div>
  );
}

// Note: Editor component now manages its own chat panel layout via editor-outer

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="page/:pageId" element={<Editor />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
